
import { initializeApp } from 'firebase/app';  // Novo estilo de importação
import { getAuth } from 'firebase/auth';  // Importa somente o serviço de autenticação que você precisa

// Configurações do Firebase - Copie essas configurações do Firebase Console
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Inicializa o Firebase App
const app = initializeApp(firebaseConfig);

// Obtém a instância de autenticação
export const auth = getAuth(app);

export default app;